export const CREATE_PROJECT = "CREATE_PROJECT";
export const CREATE_PROJECT_ERROR = "CREATE_PROJECT_ERROR";
